import type { PiniaPluginContext } from 'pinia'

type LogRocket = {
  log: (name: string, data: unknown) => void
}

type Sanitizer = (data: unknown) => unknown

export function createPiniaLogrocketPlugin(
  logrocket: LogRocket,
  sanitizer: Sanitizer = (data) => data,
) {
  return ({ store }: PiniaPluginContext) => {
    store.$subscribe((mutation) => {
      const sanitized = sanitizer({
        storeId: mutation.storeId,
        type: mutation.type,
        events: mutation.events,
      })

      if (sanitized) {
        logrocket.log('[PINIA:MUTATION]', sanitized)
      }
    })

    store.$onAction(({ name, store: actionStore, args, after, onError }) => {
      const actionData = {
        storeId: actionStore.$id,
        action: name,
        args,
      }

      const sanitized = sanitizer(actionData)

      if (sanitized) {
        logrocket.log('[PINIA:ACTION]', sanitized)
      }

      after((result) => {
        const resultData = sanitizer({
          storeId: actionStore.$id,
          action: name,
          result,
        })

        if (resultData) {
          logrocket.log('[PINIA:ACTION:RESULT]', resultData)
        }
      })

      onError((error) => {
        logrocket.log('[PINIA:ACTION:ERROR]', {
          storeId: actionStore.$id,
          action: name,
          error: error instanceof Error ? error.message : String(error),
        })
      })
    })
  }
}
